<script>
  import { getContext } from "svelte";
  import ProfileForm from "./ProfileForm.svelte";

  const { open, close } = getContext("simple-modal");

  const openProfileChangeForm = () => {
    open(ProfileForm, { close: closeProfileChangeForm });
  };

  const closeProfileChangeForm = () => {
    close(ProfileForm);
  };
</script>

<div class="p-4 my-6 bg-gray-50 bg-opacity-90 rounded-3xl w-72">
  <button
    class="w-full py-3 text-white rounded-md bg-gradient-to-r from-fcred to-white focus:outline-none hover:bg-gray-700 hover:shadow-none"
    on:click={openProfileChangeForm}>Profil anpassen</button
  >
</div>
